/**
 * Brand — Hiretape lockup + mark.
 *
 * The full combo mark + wordmark lives in /public/hiretape-logo.png and
 * is rendered by `<Brand>` (default export). For tight spaces (sidebar
 * header) we use `<BrandMark>` which renders the same lockup at a
 * smaller size — keeping a single source of truth so the logo can be
 * swapped in one file.
 *
 * Default sizing: 28px tall. BrandMark defaults to 24px (used in the
 * sidebar). Width auto-scales because the source PNG preserves aspect
 * ratio.
 */

export default function Brand({ size = 28, className = "", testId = "brand-lockup" }) {
  return (
    <img
      src="/hiretape-logo.png"
      alt="Hiretape"
      className={className}
      style={{ height: `${size}px`, width: "auto", display: "inline-block" }}
      data-testid={testId}
    />
  );
}

/**
 * Compact variant for the sidebar / nav. Visually identical to <Brand>
 * but with a smaller default height. Exported as a named export to
 * preserve the existing import-shape across the app (AppShell, SignUp,
 * SignIn, AcceptInvite, Onboarding, Forbidden).
 */
export function BrandMark({ size = 24, className = "", testId = "brand-mark" }) {
  return (
    <img
      src="/hiretape-logo.png"
      alt="Hiretape"
      className={className}
      style={{ height: `${size}px`, width: "auto", display: "inline-block" }}
      data-testid={testId}
    />
  );
}
